<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-30 14:40:53
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\security\components\detail.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="70%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看</div>
      <div>
        <el-button @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <el-form ref="form" label-width="100px" label-suffix="：">
        <div v-if="securityInfo.scannum > 3" class="tsbox red">
          产品已被{{ securityInfo.scannum }}人扫描，存在防伪追溯风险
        </div>
        <div class="box-title">产品信息</div>
        <div>
          <el-form-item label="产品UDI码">
            <div class="form-content" :title="securityInfo.completeCode">{{ securityInfo.completeCode }}</div>
          </el-form-item>
          <el-form-item label="产品名称">
            <div class="form-content" :title="detialInfo.appletUdiProductInfoVo.productName">{{
              detialInfo.appletUdiProductInfoVo.productName }}</div>
          </el-form-item>
          <el-form-item label="规格型号">
            <div class="form-content" :title="detialInfo.appletUdiProductInfoVo.specifiction">{{
              detialInfo.appletUdiProductInfoVo.specifiction }}</div>
          </el-form-item>
          <el-form-item v-for="(item, index) in detialInfo.codeInfoVoList" :key="index" :label="item.aidName">
            <div class="form-content" :title="item.aidContent">{{ item.aidContent }}</div>
          </el-form-item>
        </div>

        <div class="box-title">扫码明细</div>
        <div v-for="(item, index) of detialInfo.appletScanAntiFakeListVoList" :key="index" class="smmx-list">
          <div class="list">
            <div class="title">
              <div style="font-weight: bold;">
                {{ item.phone }}
              </div>
              <div style="color: #013288;">
                扫码{{ item.scanNum }}次
              </div>
            </div>
            <div class="main-container">
              <div v-for="(addressInfo, index1) of item.scanAddressLists" :key="index1" class="text">
                <div v-if="addressInfo.scanArea" class="form-content">{{ addressInfo.scanArea }}</div>
                <div v-else class="gray">无法获取位置信息</div>
                <div></div>
                <div class="time">
                  {{ addressInfo.scanTime ? parseTime(addressInfo.scanTime, '{y}-{m}-{d} {h}:{i}:{s}') : null }}
                </div>
              </div>
            </div>
          </div>
        </div>

      </el-form>
    </el-card>
  </el-drawer>
</template>

<script>
import { getSecurity } from '@/api/security'
export default {
  name: 'DetialInventory',
  filters: {
    formatStatus(value, roleType) {
      if (roleType === '1') {
        return "疑似窜货"
      }
      if (value) {
        return value === 'suspected_cross_shipped' ? "疑似窜货" : "未窜货"
      }
      return ''
    },
    formatRole(value, opName) {
      if (value === '0') {
        return `监管员-${opName}`
      }
      return '普通用户'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    securityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      detialInfo: {
        appletUdiProductInfoVo: {},
        appletAntifakeRecordVo: {},
        deliveryInfoVo: {},
        codeInfoVoList: [],
      },
    }
  },
  computed: {
    area() {
      if (!this.detialInfo.appletAntifakeRecordVo) {
        return ''
      }
      const { provinceName = '', cityName = '', countyName = '' } = this.detialInfo.appletAntifakeRecordVo
      return `${provinceName}${cityName}${countyName}`
    }
  },
  created() {
    if (this.securityInfo.completeCode) {
      this.getDetial()
    }
  },
  // 方法集合
  methods: {
    getDetial() {
      this.loading = true
      getSecurity({ udiCode: this.securityInfo.completeCode }).then((res) => {
        this.$set(this, 'detialInfo', res.data)
        console.log(this.detialInfo);
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style>
.form-content {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style scoped lang="less">
.el-form .el-form-item {
    margin-bottom: 8px !important;
}
.smmx-list {
  width: 500px;
  display: block;
  margin: 0;
  padding: 0;

  .list {
    padding: 0 0 15px 0;
    margin: 0 0 15px 0;

    .title {
      display: flex;
      justify-content: space-between;
      margin: 0 0 16px 0;
      padding: 0;
      color: #000;
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
    }

    .main-container {
      padding: 4px 24px 4px 4px;
      background: rgb(250, 250, 250);

      .text {
        display: grid;
        grid-template-columns: auto 24px 150px;
        grid-row-gap: 12px ;
        margin: 16px 0;
        padding: 0;
        color: #333;
        font-size: 14px;
        justify-content: space-between;

        .gray {
          color: rgba(0, 0, 0, 0.45);
        }

        .time {
          color: rgba(0, 0, 0, 0.25);
        }

        span {
          margin: 0 15px 0 0;
        }
      }
    }
  }
}
</style>
